import Box from "@/main/components/shared/box";
import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	> h2 {
		font-weight: bold;
	}
`;

export const ContainerForm = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 20px;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		flex-direction: column;
	}
`;
export const AreaButtonFilters = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: end;
	gap: 20px;

	@media (max-width: 600px) {
		flex-direction: column;

		button {
			max-width: 100%;
			margin: 0;
		}
	}
`;

export const RowInput = styled.div`
	flex: 1;
	max-width: 460px;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		max-width: 100%;
	}
`;

export const BoxPackWorkflow = styled(Box)`
	margin-top: 15px;
	background-color: ${({ theme }) => theme.white};
	position: relative;
`;

export const ContainerPackWorkflow = styled.div`
	display: grid;
	grid-template-columns: 0.1fr 1fr;
	grid-template-rows: 1fr;
	grid-column-gap: 10px;
	grid-row-gap: 0px;
	margin-top: 35px;
`;

export const BoxListItemDragAndDrop = styled.div`
	padding: 35px 0;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		width: 100%;
		max-width: 100%;
		overflow-y: hidden;
	}
`;

export const BoxVerticalLineWithArrows = styled.div`
	display: flex;
	justify-content: center;

	span {
		text-align: center;
		writing-mode: vertical-lr;
		transform: scaleX(-1) scaleY(-1);
		font-size: 18px;
	}
`;

export const AreaButton = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 20px;
	margin-top: 25px;
	margin-bottom: 25px;

	button {
		margin: 0;
	}

	@media (max-width: 600px) {
		flex-direction: column;

		button {
			max-width: 100%;
		}
	}
`;

interface ITextInfo {
	error: boolean;
}
export const TextInfo = styled.p<ITextInfo>`
	position: absolute;
	right: 16px;
	top: 16px;
	color: ${(props) => (props.error ? ({ theme }) => theme.red : ({ theme }) => theme.pantone2726C)};

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		position: relative;
		text-align: right;
	}
`;
